const containerWidth = '100%';

const styles = theme => ({
  playerInfoColumn: {
    display: 'flex',
    justifyContent: 'center',
  },
  playerCompContainer: {
    height: '50px',
  },
  // container: props => ({
  //   width: props.containerWidthPx || containerWidth,
  // }),
  // IconAndNameColumn: {
  iconAndNameColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    // solving empty role issue
    // width: '59.6px',
    // justifyContent: 'center',
    // width: '59.6px',
  },
  iconAndNameContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  role: {
    background: 'linear-gradient(90deg, #3E87DD 0%, #4BBFF1 100%);',
    color: 'white',
    padding: '0px 5px',
    textAlign: 'center',
    borderRadius: '15px',
    // solving role of BIG_BLIND
    // fontSize: 10,
    // // solving the issue of using it in HistoryDrawer
    // height: 20,
    // lineHeight: '20px',
    fontSize: 8,
  },
  userName: {
    fontSize: 8,
    marginLeft: '7px',
    width: '100%',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 1,
    overflow: 'hidden',
  },
  actionColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'flex-start',
    // minWidth: 50,
    // },
    // userName: {
    //   fontSize: '12px',
    // },
    // actionBox: {
    //   flexWrap: 'nowrap',
    minWidth: 50,
    transform: 'translateX(-5px)',
  },
  triangle: {
    marginTop: 5,
    width: 0,
    height: 0,
    borderTop: '7px solid white',
    borderLeft: '7px solid transparent',
  },
  actionBox: {
    background: 'white',
    // padding: '0 5px',
    // maxWidth: 50,
    // lineHeight: '22px',
    minWidth: 40,
    color: 'black',
    borderRadius: '3px',
    height: 28,
    fontSize: 9,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // alignItems: 'center',
    overflow: 'hidden',
    lineHeight: '9px',
    whiteSpace: 'pre-line',
  },
  actionSpan: {
    width: '100%',
    textAlign: 'center',
  },
  actionAmountSpan: {
    textAlign: 'center',

    '& .ant-statistic': {
      '& .ant-statistic-content-prefix': {
        marginRight: '0px',
      },
    },
  },
});

export default styles;
